import React from "react";
import constants from "../constants/constants";

// Allow only valid Google Doc IDs
const isValidDocId = (id) =>
    typeof id === "string" &&
    /^[A-Za-z0-9_-]{20,}$/.test(id);

const UpdateLogs = () => {
    if (!isValidDocId(constants.GOOGLE_DOC_ID)) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <p className="text-red-600 font-medium">
                    Update log is currently unavailable.
                </p>
            </div>
        );
    }

    const documentUrl = `https://docs.google.com/document/d/${constants.GOOGLE_DOC_ID}/preview`;

    return (
        <main className="min-h-screen bg-gray-100">
            <div className="h-screen flex flex-col overflow-hidden">
                <header className="p-4 text-center text-3xl font-bold">
                    {constants.UpdateLogsHeader}
                </header>

                <iframe
                    title="Update Logs"
                    src={documentUrl}
                    className="flex-1 w-full border-0"
                    loading="lazy"
                    sandbox="allow-scripts allow-same-origin"
                    referrerPolicy="strict-origin-when-cross-origin"
                />
            </div>
        </main>
    );
};

export default UpdateLogs;